import React, { useEffect, useState, useRef } from "react";
import axios from '../../axios/axiosconf';

import { getHoraInicio, getHoraFin } from "../../../resources/Helper";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import Swal from 'sweetalert2';
import { usuarioTieneFirma, usuarioTieneRegistro, tiposDocumento, citaSeCruza, citaExistenteSeCruza } from "../../../resources/Helper";
import { baseUrl } from "../../../resources/Constants";

function FormNuevaCita(props) {

    const [modalContainerStatus, setModalContainerStatus] = useState('');
    const [modalBackdropStatus, setModalBackdropStatus] = useState('zindex-back');

    // Helper para mostrar warning de WhatsApp si el límite fue alcanzado
    const checkWhatsappWarning = (response) => {
        if (response.data && response.data.whatsapp_warning) {
            const msg = response.data.whatsapp_warning;
            const isLimite = msg.toLowerCase().includes('límite') || msg.toLowerCase().includes('limite');
            const isSinConfigurar = msg.toLowerCase().includes('sin límite') || msg.toLowerCase().includes('sin limite') || msg.toLowerCase().includes('no configurad');
            const isDesactivado = msg.toLowerCase().includes('desactivado');

            let title, html;
            if (isSinConfigurar) {
                title = 'WhatsApp no disponible';
                html = '<p>La cita se guardó correctamente.</p><p>Tu plan actual no incluye notificaciones por WhatsApp. Contacta al administrador del sistema para activar este servicio.</p>';
            } else if (isLimite) {
                title = 'Límite de WhatsApp alcanzado';
                html = '<p>La cita se guardó correctamente, pero la notificación por WhatsApp no se pudo enviar.</p><p>Contacte al administrador del sistema para ampliar su plan de mensajes.</p>';
            } else if (isDesactivado) {
                title = 'WhatsApp desactivado';
                html = '<p>La cita se guardó correctamente.</p><p>El servicio de WhatsApp se encuentra desactivado. Contacte al administrador del sistema para reactivarlo.</p>';
            } else {
                title = 'WhatsApp no enviado';
                html = `<p>La cita se guardó correctamente, pero la notificación por WhatsApp no se pudo enviar.</p><p><small>${msg}</small></p>`;
            }

            Swal.fire({
                icon: 'warning',
                title,
                html,
                confirmButtonText: 'Entendido',
                confirmButtonColor: '#3085d6'
            });
        }
    };

    // Handler reutilizable para éxito al editar cita
    const handleEditCitaSuccess = (response) => {
        setLoading(false);
        checkWhatsappWarning(response);
        props.reloadCitasAgenda();
        cerrar();
        resetForm();
    };
    const [modalState, setModalState] = useState(props.modalState);
    const [loading, setLoading] = useState(false);
    const [estadosCita, setEstadosCita] = useState([]);
    const [unidadesAtencion, setUnidadesAtencion] = useState([]);
    const [profesionales, setProfesionales] = useState([]);

    const [idPacienteExistente, setIdPacienteExistente] = useState(props.idPacienteExistente || '-1');
    const [idCita, setIdCita] = useState(props.idCita || '');
    const [primerNombre, setPrimerNombre] = useState(props.primerNombre || '');
    const [segundoNombre, setSegundoNombre] = useState(props.segundoNombre || '');
    const [primerApellido, setPrimerApellido] = useState(props.primerApellido || '');
    const [segundoApellido, setSegundoApellido] = useState(props.segundoApellido || '');
    const [email, setEmail] = useState(props.email || '');
    const [celular, setCelular] = useState(props.celular || '');
    const [tipoDocumento, setTipoDocumento] = useState(props.tipoDocumento || '');
    const [numeroDocumento, setNumeroDocumento] = useState(props.numeroDocumento || '');

    const [fechaCita, setFechaCita] = useState(props.fecha || '');
    const [horaCita, setHoraCita] = useState(props.hora || '');
    const [idUsers, setIdUsers] = useState(props.profesionalAsignado || '');
    const [idUsuarioAsigna, setIdUsuarioAsigna] = useState(props.usuarioAsigna || '');
    const [horaAtencionCita, setHoraAtencionCita] = useState(props.horaAtencionCita || '');
    const [minutoCita, setMinutoCita] = useState(props.minutoCita || '');
    const [ampmCita, setAmpmCita] = useState(props.ampmCita || '');
    const [duracionCita, setDuracionCita] = useState(props.duracionCita || '');
    const [estadoCita, setEstadoCita] = useState(props.estadoCita || '');
    const [unidadAtencion, setUnidadAtencion] = useState(props.unidadAtencion || '');
    const [motivoConsulta, setMotivoConsulta] = useState(props.motivoConsulta || '');

    const [nombreProfesionalAsignado, setNombreProfesionalAsignado] = useState(props.nombreProfesionalAsignado || '');
    const [nombreUsuarioAsigna, setNombreUsuarioAsigna] = useState(props.nombreUsuarioAsigna || '');
    const [puedeAtender, setPuedeAtender] = useState(props.puedeAtender || false);
    const [idPaciente, setIdPaciente] = useState(props.idPaciente || '');

    const [searchResults, setSearchResults] = useState([]);
    const [searchResultsState, setSearchResultsState] = useState('');
    const [noResultado, setNoResultado] = useState('none');

    const [errorlist, setErrorlist] = useState({});
    const [verCita, setVerCita] = useState(props.verCita || false);
    const [primeraVez, setPrimeraVez] = useState(props.primeraVez || false);
    const [estadoElementosNotificacion, setEstadoElementosNotificacion] = useState('none');

    const [notificarWpp, setNotificarWpp] = useState(false);
    const [notificarEmail, setNotificarEmail] = useState(false);
    const [estadoBtnAtender, setEstadoBtnAtender] = useState('hide');
    const [estadoBtnCompletar, setEstadoBtnCompletar] = useState('hide');
    const [idPacienteProximaCita, setIdPacienteProximaCita] = useState(props.agendarCitaPaciente || '');
    const [readOnlyProfesional, setReadOnlyProfesional] = useState(props.bloquearProfesional || false);
    const [readOnlyEstadoCita, setReadOnlyEstadoCita] = useState(props.bloquearEstadoCita || false);
    const [estadoPorDefecto, setEstadoPorDefecto] = useState(props.estadoPorDefecto || '');

    const [stepDuracionCita, setStepDuracionCita] = useState(props.stepCita || 15);
    const [permisos, setPermisos] = useState([]);
    const [agendas, setAgendas] = useState([]);
    let history = useHistory();

    const [showModalCompletarInfo, setShowModalCompletarInfo] = useState(false);

    const refPrimerNombre = useRef();
    const refSegundoNombre = useRef();
    const refPrimerApellido = useRef();
    const refSegundoApellido = useRef();
    const refDocumento = useRef();
    const refTipoDocumento = useRef();
    const refEmail = useRef();
    const refCelular = useRef();

    function handleNotificarWpp() {
        setNotificarWpp(prev => !prev);
    }

    function handleNotificarEmail() {
        setNotificarEmail(prev => !prev);
    }

    // Oculta el formulario de cita
    const cerrar = () => {
        setModalContainerStatus('');
        setModalBackdropStatus('zindex-back');
        resetForm();
        props.closeModal();
    }

    // Muestra el formulario de cita
    const show = () => {
        setModalContainerStatus('show');
        setModalBackdropStatus('show');
    }

    // Función para guardar la cita
    const guardarCita = (userdata, hc) => {
        const conf = {
            client_id: userdata.client_id,
            primer_nombre: primerNombre,
            segundo_nombre: segundoNombre,
            primer_apellido: primerApellido,
            segundo_apellido: segundoApellido,
            email: email,
            celular: celular,
            tipo_documento: tipoDocumento,
            numero_documento: numeroDocumento,

            fecha_cita: fechaCita,
            hora_atencion_cita: horaAtencionCita,
            minuto_cita: minutoCita,
            ampm: ampmCita,
            hora_cita: hc,
            duracion_cita: duracionCita,
            estado_cita: estadoCita,
            id_users: idUsers,
            id_usuario_asigna: userdata.user_id,
            id_unidad_atencion: unidadAtencion,
            motivo_consulta: motivoConsulta,
            id_paciente_existente: idPacienteExistente,
            id_paciente_proxima_cita: idPacienteProximaCita,

            notificar_wpp: notificarWpp ? 1 : 0,
            notificar_email: notificarEmail ? 1 : 0,

            id_persona: userdata.id_persona,
            id_cliente_escritorio: userdata.id_cliente_escritorio,

            mensaje_wpp: 'Hola ' + primerNombre + ' ' + segundoNombre + ', te hemos agendado una cita para el ' + fechaCita
        };

        axios.post('/cita', conf)
            .then(response => {
                setLoading(false);
                checkWhatsappWarning(response);
                localStorage.setItem('msgtoast', 'La cita ha sido agendada.');
                props.reloadCitasAgenda();
                resetForm();
                cerrar();
            })
            .catch(error => {
                setLoading(false);
                if (error.response && error.response.status === 422) {
                    setErrorlist(error.response.data.errors || {});
                } else {
                    setErrorlist({
                        general: ["Error inesperado, intenta de nuevo."]
                    });
                }
            });

    }

    // Handler para cuando se guarda una cita nueva o una existente
    const handleSubmit = (e) => {
        e.preventDefault();

        console.log('✅ handleSubmit ejecutado');

        console.log('handleSubmit ejecutado');
        // VALIDACIÓN BÁSICA
        if (!primerNombre || !primerApellido || !fechaCita || !horaAtencionCita || !minutoCita || !ampmCita || !duracionCita || !estadoCita || !idUsers) {
            setErrorlist({ general: ['Por favor complete todos los campos requeridos'] });
            return;
        }

        console.log('Iniciando guardado...');
        setLoading(true);
        let userdata = [];

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        let hora24 = horaAtencionCita;
        if (ampmCita === 'pm' && parseInt(horaAtencionCita) < 12) {
            hora24 = parseInt(horaAtencionCita) + 12;
        } else if (ampmCita === 'am' && horaAtencionCita === '12') {
            hora24 = '00';
        }

        let hc = `${hora24.toString().padStart(2, '0')}:${minutoCita}:00`;

        // Si la cita es nueva...
        if (!verCita) {
            let citasDia = [];
            const conf2 = {
                headers: { Authorization: 'Bearer ' + userdata.access_token },
                params: { uid: idUsers, fecha: fechaCita }
            };

            // Se verifica que la nueva cita no se cruce con otra ya existente...
            axios.get('citas-dia-profesional', conf2)
                .then(response => {
                    citasDia = response.data;
                    // Si la nueva cita no se cruza con otra, agendar la nueva cita...
                    if (!citaSeCruza(fechaCita, hc, duracionCita, citasDia)) {

                        // Verificar unidad solo si está seleccionada
                        if (unidadAtencion) {
                            let citasDiaUnidad = [];
                            const conf3 = {
                                headers: { Authorization: 'Bearer ' + userdata.access_token },
                                params: { id_unidad: unidadAtencion, fecha: fechaCita }
                            };

                            axios.get('citas-dia-unidad', conf3)
                                .then(response => {
                                    citasDiaUnidad = response.data;
                                    if (!citaSeCruza(fechaCita, hc, duracionCita, citasDiaUnidad)) {
                                        guardarCita(userdata, hc);
                                    } else {
                                        setLoading(false);
                                        setErrorlist({ id_unidad: 'La unidad de atención seleccionada está ocupada en este horario' });
                                    }
                                })
                                .catch(error => {
                                    console.log('Error verificando unidad:', error);
                                    // Si hay error, proceder igual
                                    guardarCita(userdata, hc);
                                });
                        } else {
                            // Si no hay unidad seleccionada, proceder directamente
                            guardarCita(userdata, hc);
                        }
                    } else {
                        setLoading(false);
                        setErrorlist({ hora_atencion_cita: 'La cita se cruza con otra cita ya existente' });
                    }
                })
                .catch(error => {
                    console.log('Error verificando profesional:', error);
                    // Si hay error, verificar unidad si está seleccionada
                    if (unidadAtencion) {
                        let citasDiaUnidad = [];
                        const conf3 = {
                            headers: { Authorization: 'Bearer ' + userdata.access_token },
                            params: { id_unidad: unidadAtencion, fecha: fechaCita }
                        };

                        axios.get('citas-dia-unidad', conf3)
                            .then(response => {
                                citasDiaUnidad = response.data;
                                if (!citaSeCruza(fechaCita, hc, duracionCita, citasDiaUnidad)) {
                                    guardarCita(userdata, hc);
                                } else {
                                    setLoading(false);
                                    setErrorlist({ id_unidad: 'La unidad de atención seleccionada está ocupada en este horario' });
                                }
                            })
                            .catch(error => {
                                console.log('Error verificando unidad:', error);
                                // Si hay error en ambas verificaciones, proceder igual
                                guardarCita(userdata, hc);
                            });
                    } else {
                        // Si no hay unidad seleccionada, proceder directamente
                        guardarCita(userdata, hc);
                    }
                });
        } else {
            // Si se está modificando una cita ya existente...
            let hac = ampmCita == 'pm' ? parseInt(horaAtencionCita) + 12 : horaAtencionCita;
            let hc = hac + ':' + minutoCita + ':00';

            const conf = {
                id: idCita,
                fecha_cita: fechaCita,
                hora_atencion_cita: horaAtencionCita,
                minuto_cita: minutoCita,
                ampm: ampmCita,
                hora_cita: hc,
                duracion_cita: duracionCita,
                estado_cita: estadoCita,
                id_users: idUsers,
                id_usuario_asigna: idUsuarioAsigna,
                id_unidad_atencion: unidadAtencion || null,
                motivo_consulta: motivoConsulta,

                id_persona: userdata.id_persona,
                id_cliente_escritorio: userdata.id_cliente_escritorio,

                notificar_wpp: notificarWpp ? 1 : 0,
                mensaje_wpp: 'Hola ' + primerNombre + ' ' + segundoNombre + ', tu cita ha sido reprogramada para el ' + fechaCita
            };

            let citasDia = [];
            const conf2 = { headers: { Authorization: 'Bearer ' + userdata.access_token }, params: { uid: idUsers, fecha: fechaCita } };


            console.log('📤 Datos enviados al backend:', JSON.stringify(conf, null, 2));
            axios.get('citas-dia-profesional', conf2)
                .then(response => {
                    citasDia = response.data;
                    if (!citaExistenteSeCruza(fechaCita, hc, duracionCita, idCita, citasDia)) {

                        if (unidadAtencion) {
                            let citasDiaUnidad = [];
                            const conf3 = { headers: { Authorization: 'Bearer ' + userdata.access_token }, params: { id_unidad: unidadAtencion, fecha: fechaCita } };

                            axios.get('citas-dia-unidad', conf3)
                                .then(response => {
                                    citasDiaUnidad = response.data;
                                    if (!citaExistenteSeCruza(fechaCita, hc, duracionCita, idCita, citasDiaUnidad)) {
                                        axios.put('/cita', conf)
                                            .then(handleEditCitaSuccess)
                                            .catch(err => {
                                                console.log(err.response.data);
                                                setErrorlist(err.response.data.errors);
                                                setLoading(false);
                                            });
                                    } else {
                                        setLoading(false);
                                        setErrorlist({ id_unidad: 'La unidad de atención seleccionada está ocupada en este horario' });
                                    }
                                })
                                .catch(error => {
                                    console.log('Error verificando unidad:', error);
                                    axios.put('/cita', conf)
                                        .then(handleEditCitaSuccess)
                                        .catch(err => {
                                            console.log(err.response.data);
                                            setErrorlist(err.response.data.errors);
                                            setLoading(false);
                                        });
                                });
                        } else {
                            // Add notification parameters to edit request
                            const editConf = {
                                ...conf,
                                notificar_email: notificarEmail ? 1 : 0,
                                notificar_wpp: notificarWpp ? 1 : 0
                            };

                            axios.put('/cita', editConf)
                                .then(handleEditCitaSuccess)
                                .catch(error => {
                                    setLoading(false);
                                    if (error.response && error.response.status === 422) {
                                        setErrorlist(error.response.data.errors || {});
                                    } else {
                                        setErrorlist({ general: ["Error inesperado: " + (error.response?.data?.message || 'Verifica la consola del servidor')] });
                                    }
                                });
                        }
                    } else {
                        setLoading(false);
                        setErrorlist({ hora_atencion_cita: 'La cita se cruza con otra cita ya existente' });
                    }
                })
                .catch(error => {
                    console.log('Error verificando profesional:', error);
                    if (unidadAtencion) {
                        let citasDiaUnidad = [];
                        const conf3 = { headers: { Authorization: 'Bearer ' + userdata.access_token }, params: { id_unidad: unidadAtencion, fecha: fechaCita } };

                        axios.get('citas-dia-unidad', conf3)
                            .then(response => {
                                citasDiaUnidad = response.data;
                                if (!citaExistenteSeCruza(fechaCita, hc, duracionCita, idCita, citasDiaUnidad)) {
                                    axios.put('/cita', conf)
                                        .then(handleEditCitaSuccess)
                                        .catch(err => {
                                            console.log(err.response.data);
                                            setErrorlist(err.response.data.errors);
                                            setLoading(false);
                                        });
                                } else {
                                    setLoading(false);
                                    setErrorlist({ id_unidad: 'La unidad de atención seleccionada está ocupada en este horario' });
                                }
                            })
                            .catch(error => {
                                console.log('Error verificando unidad:', error);
                                axios.put('/cita', conf)
                                    .then(handleEditCitaSuccess)
                                    .catch(err => {
                                        console.log(err.response.data);
                                        setErrorlist(err.response.data.errors);
                                        setLoading(false);
                                    });
                            });
                    } else {
                        axios.put('/cita', conf)
                            .then(handleEditCitaSuccess)
                            .catch(err => {
                                console.log(err.response.data);
                                setErrorlist(err.response.data.errors);
                                setLoading(false);
                            });
                    }
                });
        }
    }

    // Cuando el componente se renderiza se cargan maestros necesarios
    // Cuando el componente se renderiza se cargan maestros necesarios
    useEffect(() => {
        let userdata = [];

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
            setPermisos(userdata.up || []);
            setIdUsuarioAsigna(userdata.user_id);
            setNombreUsuarioAsigna(userdata.user_name + ' ' + userdata.user_lastname);

            // 🔒 Usar axios que ya tiene el token configurado
            Promise.all([
                axios.get('/estados-cita').catch(err => { console.log('Error estados:', err); return { data: [] }; }),
                axios.get('/unidades-atencion').catch(err => { console.log('Error unidades:', err); return { data: [] }; }),
                axios.get('/agendas-usuario').catch(err => { console.log('Error agendas:', err); return { data: [] }; })
            ])
            .then(([estadosRes, unidadesRes, agendasRes]) => {
                const estados = estadosRes.data || [];
                const unidades = unidadesRes.data || [];
                const agendas = agendasRes.data || [];
                
                setEstadosCita(estados);
                setUnidadesAtencion(unidades);
                setAgendas(agendas);
                
                // Set default state if not already set
                if (!estadoCita && estados.length > 0) {
                    setEstadoCita(estados[0].id);
                }
            })
            .catch(error => {
                console.error('Error loading data:', error);
            });
        }
    }, []);

    // Se controla el estado de visualización del popup
    useEffect(() => {
        if (props.modalState == 'visible') {
            show();

            setIdCita(props.idCita || '');
            setPrimerNombre(props.primerNombre || '');
            setSegundoNombre(props.segundoNombre || '');
            setPrimerApellido(props.primerApellido || '');
            setSegundoApellido(props.segundoApellido || '');
            setEmail(props.email || '');
            setCelular(props.celular || '');
            setTipoDocumento(props.tipoDocumento || '');
            setNumeroDocumento(props.numeroDocumento || '');

            setDuracionCita(props.duracionCita || '');
            setEstadoCita(props.estadoCita || (estadosCita.length > 0 ? estadosCita[0].id : ''));
            setUnidadAtencion(props.unidadAtencion || '');
            setMotivoConsulta(props.motivoConsulta || '');
            setFechaCita(props.fecha || '');
            setHoraCita(props.hora || '');

            setHoraAtencionCita(props.horaAtencionCita || '');
            setMinutoCita(props.minutoCita || '');
            setAmpmCita(props.ampmCita || '');

            setVerCita(props.verCita || false);
            setPuedeAtender(props.puedeAtender || false);
            setIdPaciente(props.idPaciente || '');

            setPrimeraVez(props.primeraVez || false);
            setIdPacienteProximaCita(props.agendarCitaPaciente || '');
            setIdUsers(props.profesionalAsignado || '');
            setStepDuracionCita(props.stepCita || 15);

            setReadOnlyEstadoCita(props.bloquearEstadoCita || false);

            if (!props.primeraVez) {
                if (props.puedeAtender) {
                    setEstadoBtnAtender('');
                    setEstadoBtnCompletar('hide');
                } else {
                    setEstadoBtnAtender('hide');
                    setEstadoBtnCompletar('');
                }
            } else {
                setEstadoBtnAtender('hide');
                setEstadoBtnCompletar('hide');
            }

            if (props.estadoCita == 5) {
                setEstadoBtnAtender('hide');
                setReadOnlyEstadoCita(true);
            }
        } else {
            cerrar();
        }
    }, [props.modalState]);

    // Se consulta el paciente por nombre, apellido o número documento
    const buscarPaciente = (e) => {
        if (e.length > 2) {
            let userdata = [];
            if (localStorage.getItem('userdata')) {
                userdata = JSON.parse(localStorage.getItem('userdata'));

                const config = {
                    headers: {
                        Authorization: 'Bearer ' + userdata.access_token
                    },
                    params: {
                        termino: e
                    }
                }

                axios.get('/pacientes?uid=' + userdata.user_id, config)
                    .then(response => {
                        if (response.status === 200) {
                            setSearchResultsState('visible');
                            setNoResultado(response.data.length > 0 ? 'none' : 'block');
                            setSearchResults(response.data);
                        }
                    })
                    .catch(error => {
                        console.log(error.response?.data);
                    });
            }
        }
    }

    // Se resetea el formulario...
    const resetForm = () => {
        if (document.getElementById('patientSearch')) {
            document.getElementById('patientSearch').value = '';
        }
        if (document.getElementById('notificarWpp')) {
            document.getElementById('notificarWpp').checked = false;
        }
        if (document.getElementById('notificarEmail')) {
            document.getElementById('notificarEmail').checked = false;
        }

        setPrimerNombre('');
        setSegundoNombre('');
        setPrimerApellido('');
        setSegundoApellido('');
        setEmail('');
        setCelular('');
        setNumeroDocumento('');
        setTipoDocumento('');
        setFechaCita('');
        setHoraCita('');
        setDuracionCita('');
        setIdPacienteExistente('-1');
        setUnidadAtencion('');
        setSearchResultsState('');
        setErrorlist({});
        setNotificarEmail(false);
        setNotificarWpp(false);
        setHoraAtencionCita('');
        setMinutoCita('');
        setAmpmCita('');
        setMotivoConsulta('');
    }

    // Cuando se obtiene el paciente existente de los resultados de búsqueda
    const agregarPaciente = (id_paciente, primer_nombre, segundo_nombre, primer_apellido, segundo_apellido, email, celular, numero_documento, tipo_documento) => {
        setPrimerNombre(primer_nombre);
        setSegundoNombre(segundo_nombre);
        setPrimerApellido(primer_apellido);
        setSegundoApellido(segundo_apellido);
        setEmail(email);
        setCelular(celular);
        setNumeroDocumento(numero_documento);
        setTipoDocumento(tipo_documento);
        setIdPacienteExistente(id_paciente);
        setSearchResultsState('');
    }

    function noResultados() {
        setNoResultado('none');
        if (document.getElementById('patientSearch')) {
            document.getElementById('patientSearch').value = "";
        }
    }

    const handleCloseModalInfo = () => setShowModalCompletarInfo(false);
    const handleCompletarInfo = () => history.push('/configuracion');

    // Acción para atender el paciente si este ya existe y su registro está completo
    const accionBtnAtenderPaciente = () => {
        if (usuarioTieneFirma() && usuarioTieneRegistro()) {
            return <Link to={'/atender-paciente?id=' + idPaciente + '&ct=' + idCita} className={'btn btn-primary ' + estadoBtnAtender}>Atender cita</Link>;
        }

        return <button onClick={() => setShowModalCompletarInfo(true)} className="btn btn-primary">Atender cita</button>
    }

    return (
        <div>
            <div className={'modal-container modal fade in ' + modalContainerStatus}>
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header modal-nueva-cita">
                            <h4 className="modal-title">Agendar cita</h4>
                            <button type="button" className="close" onClick={() => cerrar()}>&times;</button>
                        </div>

                        <div className="modal-body modal-nueva-cita" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                            <form id="role-form" onSubmit={handleSubmit}>
                                <div id="infobasica">
                                    <div className="card-body card-body-mobile">
                                        <div className="row">
                                            <div className="col-md-6" style={{ paddingRight: '14px' }}>
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label htmlFor="patientSearch">Buscar paciente</label>
                                                            <input type="text" name="patientSearch" className="form-control" id="patientSearch" placeholder="Buscar por nombre, apellido o # de documento" autoComplete="off" autoFocus onChange={(e) => buscarPaciente(e.target.value)} onBlur={noResultados} />
                                                        </div>
                                                        <div className={'search-bar ' + searchResultsState}>
                                                            <ul>
                                                                <li key={'k0'} style={{ display: noResultado }} className="no-resultados">No se encontraron resultados...</li>
                                                                {searchResults.map((resultado) => (
                                                                    <li key={'k' + resultado.id}>
                                                                        <Link to='#' onClick={() => agregarPaciente(resultado.id, resultado.primer_nombre, resultado.segundo_nombre, resultado.primer_apellido, resultado.segundo_apellido, resultado.email, resultado.celular, resultado.numero_documento, resultado.tipo_documento)}>
                                                                            {resultado.primer_nombre} {resultado.segundo_nombre} {resultado.primer_apellido} {resultado.segundo_apellido}
                                                                        </Link>
                                                                    </li>
                                                                ))}
                                                            </ul>


                                                            {Object.keys(errorlist).length > 0 && (
                                                                <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                                                    <ul className="mb-0">
                                                                        {Object.entries(errorlist).map(([field, messages]) =>
                                                                            (Array.isArray(messages) ? messages : [messages]).map((msg, i) => <li key={field + i}>{msg}</li>)
                                                                        )}
                                                                    </ul>
                                                                </div>
                                                            )}


                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col">
                                                        <div className="form-group">
                                                            <label htmlFor="primer-nombre">Primer Nombre</label>
                                                            <input type="text" name="primer_nombre" ref={refPrimerNombre} className="form-control" id="primer-nombre" value={primerNombre} onChange={(e) => setPrimerNombre(e.target.value)} />
                                                            <div className="invalid-feedback visible">
                                                                {errorlist.primer_nombre}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col">
                                                        <div className="form-group">
                                                            <label htmlFor="segundo-nombre">Segundo Nombre</label>
                                                            <input type="text" name="segundo_nombre" ref={refSegundoNombre} className="form-control" id="segundo-nombre" value={segundoNombre} onChange={(e) => setSegundoNombre(e.target.value)} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col">
                                                        <div className="form-group">
                                                            <label htmlFor="primer-apellido">Primer Apellido</label>
                                                            <input type="text" name="primer_apellido" ref={refPrimerApellido} className="form-control" id="primer-apellido" value={primerApellido} onChange={(e) => setPrimerApellido(e.target.value)} />
                                                            <div className="invalid-feedback visible">
                                                                {errorlist.primer_apellido}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col">
                                                        <div className="form-group">
                                                            <label htmlFor="segundo-apellido">Segundo Apellido</label>
                                                            <input type="text" name="segundo_apellido" ref={refSegundoApellido} className="form-control" id="segundo-apellido" value={segundoApellido} onChange={(e) => setSegundoApellido(e.target.value)} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col">
                                                        <div className="form-group">
                                                            <label htmlFor="email">Email</label>
                                                            <input type="email" name="email" ref={refEmail} className="form-control" id="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                                                            <div className="invalid-feedback visible">
                                                                {errorlist.email}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col">
                                                        <div className="form-group">
                                                            <label htmlFor="celular">Celular</label>
                                                            <input type="text" name="celular" ref={refCelular} className="form-control" id="celular" value={celular} onChange={(e) => setCelular(e.target.value)} />
                                                            <div className="invalid-feedback visible">
                                                                {errorlist.celular}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col">
                                                        <div className="form-group">
                                                            <label htmlFor="tipo-documento">Tipo documento</label>
                                                            <select name="tipo_documento" className="form-control" id="tipo-documento" ref={refTipoDocumento} value={tipoDocumento} onChange={(e) => setTipoDocumento(e.target.value)} >
                                                                <option key={'td0'} value=""></option>
                                                                {Object.keys(tiposDocumento).map((key, index) => (
                                                                    <option key={key} value={key}>{key} - {tiposDocumento[key]}</option>
                                                                ))}
                                                            </select>
                                                            <div className="invalid-feedback visible">
                                                                {errorlist.tipo_documento}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col">
                                                        <div className="form-group">
                                                            <label htmlFor="documento">No. de documento</label>
                                                            <input type="text" name="numero_documento" className="form-control" id="documento" ref={refDocumento} value={numeroDocumento} onChange={(e) => setNumeroDocumento(e.target.value)} />
                                                            <div className="invalid-feedback visible">
                                                                {errorlist.numero_documento}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <input type="checkbox" name="notificar_wpp" id="notificarWpp" style={{ marginRight: '10px' }} onChange={() => handleNotificarWpp()} />
                                                            <label htmlFor="notificarWpp">Notificar vía WhatsApp</label>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <input type="checkbox" name="notificar_email" id="notificarEmail" style={{ marginRight: '10px' }} onChange={() => handleNotificarEmail()} />
                                                            <label htmlFor="notificarEmail">Notificar vía e-mail</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-6 form-cita-padding">
                                                <div className="row">
                                                    <div className="col">
                                                        <div className="form-group">
                                                            <label htmlFor="appointmentDate">Fecha</label>
                                                            <input type="date" name="fecha_cita" className="form-control" id="appointmentDate" defaultValue={props.fecha} onChange={(e) => setFechaCita(e.target.value)} />
                                                            <div className="invalid-feedback visible">
                                                                {errorlist.fecha_cita}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col">
                                                        <div className="form-group">
                                                            <label htmlFor="appointmentTime">Hora</label>
                                                            <div className="control-hora">
                                                                <select name="hora_atencion_cita" className="form-control" value={horaAtencionCita} onChange={(e) => setHoraAtencionCita(e.target.value)}>
                                                                    <option key={'hc0'} value=""></option>
                                                                    <option key={'hc1'} value="00">00</option>
                                                                    <option key={'hc2'} value="01">01</option>
                                                                    <option key={'hc3'} value="02">02</option>
                                                                    <option key={'hc4'} value="03">03</option>
                                                                    <option key={'hc5'} value="04">04</option>
                                                                    <option key={'hc6'} value="05">05</option>
                                                                    <option key={'hc7'} value="06">06</option>
                                                                    <option key={'hc8'} value="07">07</option>
                                                                    <option key={'hc9'} value="08">08</option>
                                                                    <option key={'hc10'} value="09">09</option>
                                                                    <option key={'hc11'} value="10">10</option>
                                                                    <option key={'hc12'} value="11">11</option>
                                                                    <option key={'hc13'} value="12">12</option>
                                                                </select>
                                                                <select name="minuto_cita" className="form-control" value={minutoCita} onChange={(e) => setMinutoCita(e.target.value)}>
                                                                    <option key={'mc1'} value=""></option>
                                                                    <option key={'mc2'} value="00">00</option>
                                                                    <option key={'mc3'} value="15">15</option>
                                                                    <option key={'mc4'} value="30">30</option>
                                                                    <option key={'mc5'} value="45">45</option>
                                                                </select>
                                                                <select name="ampm" className="form-control" value={ampmCita} onChange={(e) => setAmpmCita(e.target.value)}>
                                                                    <option key={'am1'} value=""></option>
                                                                    <option key={'am2'} value="am">AM</option>
                                                                    <option key={'am3'} value="pm">PM</option>
                                                                </select>
                                                            </div>
                                                            <div className="invalid-feedback visible">
                                                                {errorlist.hora_atencion_cita}
                                                                {errorlist.minuto_cita}
                                                                {errorlist.ampm}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col">
                                                        <div className="form-group">
                                                            <label htmlFor="appointmentDuration">Duración</label>
                                                            <input type="number" name="duracion_cita" min={stepDuracionCita} max="120" step={stepDuracionCita} className="form-control" id="appointmentDuration" value={duracionCita} onChange={(e) => setDuracionCita(e.target.value)} />
                                                            <div className="invalid-feedback visible">
                                                                {errorlist.duracion_cita}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col">
                                                        <div className="form-group">
                                                            <label htmlFor="appointmentState">Estado de la cita</label>
                                                            <select
                                                                name="estado_cita"
                                                                className="form-control"
                                                                id="appointmentState"
                                                                value={estadoCita}
                                                                onChange={(e) => setEstadoCita(e.target.value)}
                                                                required
                                                            >
                                                                <option value=""></option>
                                                                {estadosCita.map((estado) => (
                                                                    <option key={`estado-${estado.id}`} value={estado.id}>
                                                                        {estado.nombre}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            <div className="invalid-feedback visible">
                                                                {errorlist.estado_cita}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col">
                                                        <div className="form-group">
                                                            <label htmlFor="appointmentPerson">Agenda asignada</label>
                                                            <select name="id_users" className="form-control" value={idUsers || ''} disabled={readOnlyProfesional} onChange={(e) => setIdUsers(e.target.value)}>
                                                                <option value=""></option>
                                                                {agendas.map((agenda) => (
                                                                    <option key={`agenda-${agenda.id}`} value={agenda.id}>{agenda.nombre}</option>
                                                                ))}
                                                            </select>
                                                            <div className="invalid-feedback visible">
                                                                {errorlist.id_users}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col">
                                                        <div className="form-group">
                                                            <label htmlFor="appointmentUser">Usuario que asigna</label>
                                                            <input type="text" name="id_usuario_asigna" className="form-control" id="appointmentUser" placeholder="Usuario que asigna" value={nombreUsuarioAsigna} readOnly />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col">
                                                        <div className="form-group">
                                                            <label htmlFor="appointmentUnit">Unidad de atención</label>
                                                            <select name="id_unidad_atencion" className="form-control" id="appointmentUnit" value={unidadAtencion} onChange={(e) => setUnidadAtencion(e.target.value)}>
                                                                <option value={''}></option>
                                                                {unidadesAtencion.map((unidadAtencionItem) => (
                                                                    <option key={`unidad-${unidadAtencionItem.id}`} value={unidadAtencionItem.id}>{unidadAtencionItem.nombre_unidad}</option>
                                                                ))}
                                                            </select>
                                                            <div className="invalid-feedback visible">
                                                                {errorlist.id_unidad}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col">
                                                        <div className="form-group">
                                                            <label htmlFor="appointmentReason">Motivo de consulta</label>
                                                            <textarea 
                                                                name="motivo_consulta" 
                                                                className="form-control" 
                                                                id="appointmentReason" 
                                                                value={motivoConsulta} 
                                                                onChange={(e) => setMotivoConsulta(e.target.value)}
                                                                rows="3"
                                                                placeholder="Describa el motivo de la consulta..."
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    {permisos.includes('crearPacientes') && idPaciente && (
                                                        <Link to={'/editar-paciente?id=' + idPaciente} className={'btn btn-primary ' + estadoBtnCompletar}>
                                                            Completar anamnesis
                                                        </Link>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>

                        <div className="modal-footer">
                            {permisos.includes('atenderPacientes') ? accionBtnAtenderPaciente() : <></>}

                            {permisos.includes('crearCitas') &&
                                <button type="button" onClick={handleSubmit} className="btn btn-primary">

                                    {verCita === true ? 'Guardar cambios' : 'Agendar cita'}

                                    &nbsp;
                                    {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null}
                                </button>
                            }

                        </div>




                    </div>
                </div>
            </div>
            <div className={'modal-backdrop fade ' + modalBackdropStatus}></div>

            <Modal show={showModalCompletarInfo} onHide={handleCloseModalInfo}>
                <Modal.Header closeButton>
                    <Modal.Title>Aún no puedes atender citas</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <p>Para atender una cita debes completar la siguiente información:</p>
                    <ul>
                        {!usuarioTieneFirma() && <li>Firma</li>}
                        {!usuarioTieneRegistro() && <li>Registro médico</li>}
                    </ul>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModalInfo}>Cancelar</Button>
                    <Button variant="primary" onClick={handleCompletarInfo}>Completar información</Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}
export default FormNuevaCita;